import { StateSchema } from 'app/config/storeConfig/types';
import { Shape } from '../types';

export const getShapes = (state: StateSchema): Shape[] => state.warehouseMapConstructor.shapes;
